import { MemberFieldTypes } from '../Types/MemberFieldTypes';
import { TextService } from '../Services/TextService';

const GetText = TextService.GetText;

export const getFieldText = (fieldType: number): string => {
    switch (fieldType) {
        case MemberFieldTypes.UniqueId:
            return GetText("EditMember_UniqueId");
        case MemberFieldTypes.FirstName:
            return GetText("EditMember_FirstName");
        case MemberFieldTypes.LastName:
            return GetText("EditMember_LastName");
        case MemberFieldTypes.Email:
            return GetText("EditMember_Email");
        case MemberFieldTypes.Email2:
            return GetText("EditMember_Email2");
        case MemberFieldTypes.Address:
            return GetText("EditMember_Address");
        case MemberFieldTypes.PostalArea:
            return GetText("EditMember_PostalArea");
        case MemberFieldTypes.PostalCode:
            return GetText("EditMember_PostalCode");
        case MemberFieldTypes.Country:
            return GetText("EditMember_Country");
        case MemberFieldTypes.Company:
            return GetText("EditMember_Company");
        case MemberFieldTypes.Title:
            return GetText("EditMember_Title");
        case MemberFieldTypes.PhoneNumber:
            return GetText("EditMember_PhoneNumber");
        case MemberFieldTypes.Extra1:
            return "Extra1";
        case MemberFieldTypes.Extra2:
            return "Extra2";
        case MemberFieldTypes.Extra3:
            return "Extra3";
        case MemberFieldTypes.Payment:
            return GetText("EditMember_Payment");
        case MemberFieldTypes.EmailNotificationPreference:
            return GetText("EditMember_EmailNotificationPreference");
        case MemberFieldTypes.SortOrder:
            return GetText("EditMember_EmailNotificationPreference");
        case MemberFieldTypes.PersonalNumber:
            return GetText("EditMember_PersonalNumber");
        case MemberFieldTypes.PhoneNumber2:
            return GetText("EditMember_PhoneNumber2");
        case MemberFieldTypes.AdressRow2:
            return GetText("EditMember_AdressRow2");
        case MemberFieldTypes.AdressRow3:
            return GetText("EditMember_AdressRow3");
        case MemberFieldTypes.JoinedDate:
            return GetText("EditMember_JoinedDate");
        case MemberFieldTypes.WebPage:
            return GetText("EditMember_WebPage");
        case MemberFieldTypes.InvoiceEmail:
            return GetText("EditMember_InvoiceEmail");
        case MemberFieldTypes.Membership:
            return GetText("EditMember_Membership");
        case MemberFieldTypes.MembershipAddon:
            return GetText("EditMember_MembershipAddon");
        default:
            return "";
    }
};

export const getFieldValueName = (fieldType: number): string | null => {
    switch (fieldType) {
        case MemberFieldTypes.UniqueId:
            return "UniqueId";
        case MemberFieldTypes.FirstName:
            return "FirstName";
        case MemberFieldTypes.LastName:
            return "LastName";
        case MemberFieldTypes.Email:
            return "Email";
        case MemberFieldTypes.Email2:
            return "Email2";
        case MemberFieldTypes.Address:
            return "Address";
        case MemberFieldTypes.PostalArea:
            return "PostalArea";
        case MemberFieldTypes.PostalCode:
            return "PostalCode";
        case MemberFieldTypes.Country:
            return "Country";
        case MemberFieldTypes.Company:
            return "Company";
        case MemberFieldTypes.Title:
            return "Title";
        case MemberFieldTypes.PhoneNumber:
            return "PhoneNumber";
        case MemberFieldTypes.Extra1:
            return "Extra1";
        case MemberFieldTypes.Extra2:
            return "Extra2";
        case MemberFieldTypes.Extra3:
            return "Extra3";
        case MemberFieldTypes.Payment:
            return "Payment";
        case MemberFieldTypes.EmailNotificationPreference:
            return "EmailNotificationPreference";
        case MemberFieldTypes.PersonalNumber:
            return "PersonalNumber";
        case MemberFieldTypes.PhoneNumber2:
            return "PhoneNumber2";
        case MemberFieldTypes.AdressRow2:
            return "AdressRow2";
        case MemberFieldTypes.AdressRow3:
            return "AdressRow3";
        case MemberFieldTypes.JoinedDate:
            return "JoinedDate";
        case MemberFieldTypes.WebPage:
            return "WebPage";
        case MemberFieldTypes.InvoiceEmail:
            return "InvoiceEmail";
        case MemberFieldTypes.Membership:
            return "Membership";
        default:
            return null;
    }
};
